import { createFileRoute, notFound } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Spinner } from '@penta/penta-shared';
import { isDevelopmentModeEnabled } from '../utils/envUtils';

export const Route = createFileRoute('/mock-login-gateway')({
  beforeLoad: () => {
    // Only allow access if mocks are enabled
    if (!isDevelopmentModeEnabled()) {
      throw notFound();
    }
  },
  component: MockLoginGateway,
});

function MockLoginGateway() {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimeout = setTimeout(() => {
      // Redirect back to login with a mock code
      // We assume this page is running on the same origin as the app
      window.location.href = '/login#code=mock-auth-code-123';
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimeout);
    };
  }, []);

  return (
    <Modal
      open
      closeOnInteractOutside={false}
      closeOnEscape={false}
      aria-label={t('mockGateway.title')}
      description={t('mockGateway.subtitle', { count: countdown })}
      data-testid="mock-login-gateway"
    >
      <Spinner size="lg" />
    </Modal>
  );
}
